import React, { useState, useEffect, version } from "react";
import { TextField, Button, Grid, MenuItem, Typography, Modal, Box } from "@mui/material";
import { protocolStateIds } from "../../../models/protocolStateIds";
import useRoles from "../../../hooks/useRoles";
import { expertResultCRUD } from "../../../http";

const ExpertForm = ({ open, onClose, relations, onSubmit, initNumber }) => {
  const { getEmployee } = useRoles();
  const [formData, setFormData] = useState({
    applicant: "",
    address: "",
    objectName: "",
    contractNumber: "", // Не заполняем initNumber, потому что это не контракт
    measurementPurpose: "",
    measuringInstruments: "",
    documentType: "",
    laboratoryName: "",
    accreditationCertificate: "",
    measurementProtocol: "",
    additionalInfo: "",
    airTemperature: "",
    humidity: "",
  });

  const measurementPurposes = ["Акустика", "Вибрация", "Температура"];
  const documentTypes = ["СП РК 2.04-105-2012", "ГОСТ 27296-2012"];

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Если contractNumber не указан, передаем его как пустую строку
    const finalData = {
      ...formData,
      contractNumber: formData.contractNumber || "",
      initNumber, // Передаем initNumber в данные, чтобы он шел в заголовок
    };

    const request = {
      number: initNumber,
      createdAt: new Date(),
      data: formData,
      version: 1,
      orderType: 1,

      referralId: relations?.referral?.id,
      filialId: relations?.referral?.filialId,
      filialDivisionId: relations?.referral?.filialDivisionId,
      departmentId: relations?.referral?.departmentId,
      divisionId: relations?.referral?.divisionId,
      createdById: getEmployee()?.id,
      stateId: protocolStateIds.created
    };
    const response = await expertResultCRUD.create(request);

    if (!response.id) {
      alert('Не удалось сохранить, попробуйте еще раз.');
      return;
    }

    await onSubmit(finalData);
  };

  return (
    <Modal open={open} onClose={onClose}>
      <Box
        sx={{
            position: 'absolute',
            top: '10%',
            bottom: '20%',
            left: '20%',
            right: '20%',
            bgcolor: 'background.paper',
            boxShadow: 24,
            overflow: 'auto',
            height: '85%',
            p: 4,
        }}
      >
        <Typography variant="h5" gutterBottom>
          {initNumber ? `Форма экспертного заключения по заявке №${initNumber}` : "Форма экспертного заключения"}
        </Typography>
        <form onSubmit={handleSubmit}>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <TextField fullWidth label="Заявитель" name="applicant" value={formData.applicant} onChange={handleChange} />
            </Grid>
            <Grid item xs={12}>
              <TextField fullWidth label="Адрес" name="address" value={formData.address} onChange={handleChange} />
            </Grid>
            <Grid item xs={12}>
              <TextField fullWidth label="Наименование объекта" name="objectName" value={formData.objectName} onChange={handleChange} />
            </Grid>
            <Grid item xs={6}>
              <TextField fullWidth label="Договор №" name="contractNumber" value={formData.contractNumber} onChange={handleChange} />
            </Grid>
            <Grid item xs={6}>
              <TextField select fullWidth label="Цель измерений" name="measurementPurpose" value={formData.measurementPurpose} onChange={handleChange}>
                {measurementPurposes.map((option) => (
                  <MenuItem key={option} value={option}>
                    {option}
                  </MenuItem>
                ))}
              </TextField>
            </Grid>
            <Grid item xs={12}>
              <TextField fullWidth multiline rows={2} label="Средства измерений" name="measuringInstruments" value={formData.measuringInstruments} onChange={handleChange} />
            </Grid>
            <Grid item xs={6}>
              <TextField select fullWidth label="Нормативный документ" name="documentType" value={formData.documentType} onChange={handleChange}>
                {documentTypes.map((option) => (
                  <MenuItem key={option} value={option}>
                    {option}
                  </MenuItem>
                ))}
              </TextField>
            </Grid>
            <Grid item xs={6}>
              <TextField fullWidth label="Испытательная лаборатория" name="laboratoryName" value={formData.laboratoryName} onChange={handleChange} />
            </Grid>
            <Grid item xs={12}>
              <TextField fullWidth label="Аттестат аккредитации" name="accreditationCertificate" value={formData.accreditationCertificate} onChange={handleChange} />
            </Grid>
            <Grid item xs={12}>
              <TextField fullWidth label="Протокол измерения" name="measurementProtocol" value={formData.measurementProtocol} onChange={handleChange} />
            </Grid>
            <Grid item xs={6}>
              <TextField fullWidth label="Температура воздуха (°С)" name="airTemperature" value={formData.airTemperature} onChange={handleChange} />
            </Grid>
            <Grid item xs={6}>
              <TextField fullWidth label="Влажность (%)" name="humidity" value={formData.humidity} onChange={handleChange} />
            </Grid>
            <Grid item xs={12} display="flex" justifyContent="space-between">
              <Button variant="outlined" color="secondary" onClick={onClose}>
                Отмена
              </Button>
              <Button type="submit" variant="contained" color="primary">
                Сохранить
              </Button>
            </Grid>
          </Grid>
        </form>
      </Box>
    </Modal>
  );
};

export default ExpertForm;
